/// <reference types="@angular/localize" />

import { enableProdMode, inject, provideAppInitializer } from '@angular/core';

import { bootstrapApplication } from '@angular/platform-browser';
import { routes } from 'app/app.routes';
import { setAppConfigSnapshot } from 'app/core/config/config-snapshot';
import { APP_CONFIG } from 'app/core/config/app-config.token';
import { loadAppConfig } from 'app/core/config/load-app-config';
import { provideCore } from 'app/core/core';
import { ExternalLinkEnhancer } from 'app/core/directives/external-link-indicator.directive';
import { AppComponent } from './app/app.component';

// Resolve runtime configuration BEFORE bootstrap, so it is available while the
// provider graph (including auth) is constructed. Falls back to the build-time
// `environment` if the runtime endpoints are unavailable (see loadAppConfig()).
loadAppConfig()
  .then((config) => {
    // Publish to the module-scope snapshot before bootstrap, for the call sites
    // that cannot inject APP_CONFIG (see core/config/config-snapshot.ts).
    setAppConfigSnapshot(config);

    if (config.production) {
      enableProdMode();
    }

    return bootstrapApplication(AppComponent, {
      providers: [
        { provide: APP_CONFIG, useValue: config },
        ...provideCore({ routes, config }),
        provideAppInitializer(() => inject(ExternalLinkEnhancer).init()),
      ],
    });
  })
  .catch((err) => {
    // console.error(err);
  });
